
import React from 'react';
import { FilterOperation } from '@/hooks/useConnectionData';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface FilterOperationSelectProps {
  value: FilterOperation;
  onChange: (value: FilterOperation) => void;
  disabled?: boolean;
  columnType?: string;
}

// Get display label for each operation
export const getOperationLabel = (operation: FilterOperation): string => {
  switch (operation) {
    case 'equals':
      return 'equals';
    case 'not_equals':
      return 'does not equal';
    case 'contains':
      return 'contains';
    case 'startsWith':
      return 'starts with';
    case 'endsWith':
      return 'ends with';
    case 'gt':
      return 'is greater than';
    case 'lt':
      return 'is less than';
    case 'gte':
      return 'is greater than or equal to';
    case 'lte':
      return 'is less than or equal to';
    case 'like':
      return 'is like';
    case 'not_like':
      return 'is not like';
    case 'is_blank':
      return 'is blank';
    case 'is_not_blank':
      return 'is not blank';
    case 'between':
      return 'is between';
    default:
      return String(operation);
  }
};

const FilterOperationSelect: React.FC<FilterOperationSelectProps> = ({
  value,
  onChange,
  disabled = false,
  columnType = 'string'
}) => {
  // Operations available for string columns
  const stringOperations: FilterOperation[] = [
    'equals',
    'not_equals',
    'contains',
    'startsWith',
    'endsWith',
    'is_blank',
    'is_not_blank'
  ];
  
  // Operations available for number columns
  const numberOperations: FilterOperation[] = [
    'equals',
    'not_equals',
    'gt',
    'lt',
    'gte',
    'lte',
    'is_blank',
    'is_not_blank'
  ];

  const dateOperations: FilterOperation[] = ['between'];
  
  // Choose operations based on column type
  const operations =
    columnType === 'date'
      ? dateOperations
      : columnType === 'number'
        ? numberOperations
        : stringOperations;
  
  return (
    <Select
      value={value}
      onValueChange={(value) => onChange(value as FilterOperation)}
      disabled={disabled}
    >
      <SelectTrigger className="h-9">
        <SelectValue placeholder="Select operation" />
      </SelectTrigger>
      <SelectContent>
        {operations.map((op) => (
          <SelectItem key={op} value={op}>
            {getOperationLabel(op)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FilterOperationSelect;
